import { Box, Typography, Stack } from '@mui/material'
import EnhancedTabs from '@common/components/Tab/EnhancedTabs'
import { CurrentActiveTabProvider } from '@common/context/CurrentActiveTabProvider'
import { TabOptionalComponentProvider } from '@common/context/TabOptionalComponentProvider'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { useParams } from 'react-router-dom'
import { createQCTasksTabs } from './qcTasksTabs'
import { QCTaskListTabsKey } from '@qc_task_list_view/constant'
import { TabConfig } from '@common/components/Tab/tabs.types'
import { QcTaskSearchProvider } from '@qc_task_list_view/context/QcTaskSearchContext'
import QcTaskListTableToolbar from '@qc_task_list_view/components/QcTaskListTableToolbar'
import { useCallback, useState } from 'react'
import { SPACING } from '@common/theme/spacing'

const SubjectQCTasks = () => {
  const { hasPermission } = useCombinedPermissions()
  const { subjectId } = useParams<{ studyId: string; subjectId: string }>()

  const [searchValue, setSearchValue] = useState<string>('')

  const handleSearch = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  const qcTasksTabs = createQCTasksTabs(subjectId)

  const filteredTabs = Object.entries(qcTasksTabs).reduce(
    (acc, [key, tab]) => {
      if (!tab.permission || hasPermission(tab.permission)) {
        acc[key as QCTaskListTabsKey] = tab
      }
      return acc
    },
    {} as Record<QCTaskListTabsKey, TabConfig>,
  )

  if (!subjectId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Subject ID is required to view subject QC tasks
        </Typography>
      </Box>
    )
  }

  return (
    <QcTaskSearchProvider value={{ searchValue, setSearchValue }}>
      <Stack spacing={SPACING.spacingMd}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <QcTaskListTableToolbar onSearch={handleSearch} searchValue={searchValue} />
        </Box>
        <CurrentActiveTabProvider>
          <TabOptionalComponentProvider>
            {Object.keys(filteredTabs).length > 0 && <EnhancedTabs tabs={filteredTabs} />}
          </TabOptionalComponentProvider>
        </CurrentActiveTabProvider>
      </Stack>
    </QcTaskSearchProvider>
  )
}

export default SubjectQCTasks
